import React from 'react';

export default ({children, className}) => {
  return (
    <div className={`ect-empty-list ${className}`}>
      <div className='ect-empty-list__search-icon' />
      <div className='ect-empty-list__text'>
        {children}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/Components/EmptyList.jsx